import { fallbackResources, SUPPORTED_LANGS } from "@/i18n";

import { useEffect, useState } from "react";
import { default as languageService } from "../services/language";
import { i18n } from "@/config";

const useLanguageProvider = () => {
  const [loaded, setLoaded] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const languages = SUPPORTED_LANGS;

  useEffect(() => {
    fetchTranslations();
  }, []);

  const fetchTranslations = async () => {
    const promises = languages.map(lang => {
      return languageService.fetchTranslations(lang)
        .then(res => {
          i18n.addResourceBundle(lang, 'common', res);
          return lang;
        })
        .catch(err => {
          console.error(err);
        });
    });

    await Promise.all(promises);

    setLoaded(true);
    setIsFetching(false);
  }

  return {
    loaded,
    isFetching,
  }
}

export default useLanguageProvider;